export const baseUrl: string = process.env.REACT_APP_API_BASE_URL;
export const signalRUrl: string = `${baseUrl}/signalr`;
export const authHeaderName: string = "X-Custom-Auth";